/**
 * URL-Schema-Whitelist für extern verlinkte Daten aus Backend-Responses.
 *
 * Per security-review LOW-2 (2026-06-21): jeder `<a href={…} target="_blank">`
 * der eine URL aus einem Backend-Field rendert, sollte das Schema gegen
 * eine Whitelist prüfen. Realistisches Risiko praktisch null (Backends sind
 * trusted), aber defense-in-depth gegen einen kompromittierten Service.
 *
 * Rückgabe `null` → der Aufrufer rendert dann ein Plain-Text-Fallback statt
 * eines klickbaren Links.
 */
const ALLOWED_SCHEMES = /^(https?|otpauth|mailto):/i;

export function safeExternalUrl(value) {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (!ALLOWED_SCHEMES.test(trimmed)) return null;
  return trimmed;
}
